import GeoProvider from '../geoProvider'

export default defineNuxtPlugin(() => {
  const geoProvider = new GeoProvider()

  return {
    provide: {
      geolocation: geoProvider,
    },
  }
})
